// Import all type icons as React components
import { ReactComponent as BugIcon } from '../svgs/Type Icons/bug.svg';
import { ReactComponent as DarkIcon } from '../svgs/Type Icons/dark.svg';
import { ReactComponent as DragonIcon } from '../svgs/Type Icons/dragon.svg';
import { ReactComponent as ElectricIcon } from '../svgs/Type Icons/electric.svg';
import { ReactComponent as FairyIcon } from '../svgs/Type Icons/fairy.svg';
import { ReactComponent as FightingIcon } from '../svgs/Type Icons/fighting.svg';
import { ReactComponent as FireIcon } from '../svgs/Type Icons/fire.svg';
import { ReactComponent as FlyingIcon } from '../svgs/Type Icons/flying.svg';
import { ReactComponent as GhostIcon } from '../svgs/Type Icons/ghost.svg';
import { ReactComponent as GrassIcon } from '../svgs/Type Icons/grass.svg';
import { ReactComponent as GroundIcon } from '../svgs/Type Icons/ground.svg';
import { ReactComponent as IceIcon } from '../svgs/Type Icons/ice.svg';
import { ReactComponent as NormalIcon } from '../svgs/Type Icons/normal.svg';
import { ReactComponent as PoisonIcon } from '../svgs/Type Icons/poison.svg';
import { ReactComponent as PsychicIcon } from '../svgs/Type Icons/psychic.svg';
import { ReactComponent as RockIcon } from '../svgs/Type Icons/rock.svg';
import { ReactComponent as SteelIcon } from '../svgs/Type Icons/steel.svg';
import { ReactComponent as WaterIcon } from '../svgs/Type Icons/water.svg';

// Map type names to their corresponding icon components
const typeIcons = {
    bug: BugIcon,
    dark: DarkIcon,
    dragon: DragonIcon,
    electric: ElectricIcon,
    fairy: FairyIcon,
    fighting: FightingIcon,
    fire: FireIcon,
    flying: FlyingIcon,
    ghost: GhostIcon,
    grass: GrassIcon,
    ground: GroundIcon,
    ice: IceIcon,
    normal: NormalIcon,
    poison: PoisonIcon,
    psychic: PsychicIcon,
    rock: RockIcon,
    steel: SteelIcon,
    water: WaterIcon
};

export default typeIcons;